<template>
    <div class="system-info-wrapper">
        <div class="system-info-section">
            <h4 class="system-info-header">{{ localizer.Localize("Header_Tenant") }}</h4>
            <span>{{ Tenant.name }}</span>
        </div>
        <hr />
        <div class="system-info-section">
            <h4 class="system-info-header">{{ localizer.Localize("Header_Roles") }}</h4>
            <div>
                <div v-for="role in displayedRoles">{{ role }}</div>
                <span v-if="displayedRoles == null || displayedRoles?.length == 0">{{ localizer.Localize("No_Roles_Text") }}</span>
                <f-button class="expand-btn" role="button" text="Button" type="ghost"
                    v-if="UserData?.roles && displayedRoles && UserData?.roles?.length > maxVisible"
                    @click="toggleExpand">
                    <f-icon icon="chevrondown" :class="{'is-expanded': isExpanded }" color="primary" />
                    <span>{{ isExpanded ? localizer.Localize("Show_Less_Text") : `+${UserData?.roles?.length - displayedRoles?.length} ${localizer.Localize("More_Text")}`
                        }}</span>
                </f-button>
            </div>
        </div>
        <hr />
        <div class="system-info-section">
            <h4 class="system-info-header">{{ localizer.Localize("Header_Version") }}</h4>
            <div>
                <div>{{ localizer.Localize("Header_Portal") }}: 2605.1</div>
                <div v-if="UserData?.releaseInfo != null">
                    {{ localizer.Localize("Header_Platform") }}:
                    {{ UserData?.releaseInfo?.platform }}
                </div>
                <div v-if="UserData?.releaseInfo != null && UserData?.releaseInfo?.consolidationModule != null">
                    {{ localizer.Localize("Header_Consolidation") }}: {{ UserData?.releaseInfo?.consolidationModule
                    }}
                </div>
                <div v-if="UserData?.releaseInfo != null && UserData?.releaseInfo?.accountRecModule != null">
                    {{ localizer.Localize("Header_Account_Rec") }}: {{ UserData?.releaseInfo?.accountRecModule }}
                </div>
                <div v-if="UserData?.releaseInfo != null && UserData?.releaseInfo?.matchingModule != null">
                    {{ localizer.Localize("Header_Transaction_Matching") }}: {{ UserData?.releaseInfo.matchingModule
                    }}
                </div>
                <div v-if="UserData?.releaseInfo != null">
                    {{ localizer.Localize("Header_AnaplanXL") }}: {{ xl3Version ?? '...' }}
                </div>
            </div>
        </div>
        <hr v-if="AXLDownloadLinkFeatureFlag" />
        <div class="system-info-section" v-if="AXLDownloadLinkFeatureFlag">
            <h4 class="system-info-header">{{ localizer.Localize("Header_Anaplan_XL_FCR") }}</h4>
            <div class="anaplan-xl-actions">
                <div class="action-buttons">
                    <CommonButton
                        :type="ButtonType.Default" 
                        :text="localizer.Localize('AnaplanXL_Download_EXE')" 
                        :title="localizer.Localize('AnaplanXL_Download_EXE_Title')"
                        icon="open"
                        @click="handleDownloadEXE"
                    />
                    <CommonButton
                        :type="ButtonType.Default" 
                        :text="localizer.Localize('AnaplanXL_Download_MSI')" 
                        :title="localizer.Localize('AnaplanXL_Download_MSI_Title')"
                        icon="open"
                        @click="handleDownloadMSI"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import XLCubedHelper from '../../../api/XLCubedHelper';
import { Localizer } from '@/api/Localizer';
import * as api from "../../../api/ApiClient";
import * as apiBase from "../../../api/ApiClientBase";
import CommonButton from "@/components/helpers/CommonButton.vue";
import { ButtonType } from "@/components/helpers/HelpersInterface";

export default defineComponent({
    components: {
        CommonButton
    },
    data() {
        return {
            localizer: new Localizer(this.$store),
            isExpanded: false,
            maxVisible: 5,
            xl3Version: null as string | null,
            ButtonType: ButtonType,
        }
    },
    methods: {
        toggleExpand() {
            this.isExpanded = !this.isExpanded
        },
        handleDownloadEXE() {
            var exe = "https://downloads.anaplan.com/anaplanxl/FCR/AnaplanXLReporting.exe";
            window.location.href = exe;
        },
        handleDownloadMSI() {
            var msi = "https://downloads.anaplan.com/anaplanxl/FCR/AnaplanXLReporting.msi";
            window.location.href = msi;
        },
        async GetXL3Version(): Promise<void> {
            const xl3Helper = new XLCubedHelper(this.$store, this.$route);
            try {
                const authClient = apiBase.AuthClient.getInstance();
                await authClient.ensureToken();
                const client = new api.FormClient(authClient);
                const rep = await await xl3Helper.getAXLVersion();
                this.xl3Version = rep || "????.?.????";
            }
            catch (err) {
                this.$store.dispatch('ShowToastError', err);
                this.xl3Version = "Error: " + (err as Error).message;
            }
        }
    },
    mounted() {
        this.GetXL3Version();
    },  
    computed: {
        Tenant(): api.Tenant { return this.$store.state.security.Tenant; },
        UserData(): api.ExtendedUserData { return this.$store.state.security.UserData; },
        AXLDownloadLinkFeatureFlag(): boolean { return this.$store.getters['security/AXLDownloadLinkFeatureFlagValue']; },
        displayedRoles() {
            return this.isExpanded
                ? this.UserData?.roles
                : this.UserData?.roles?.slice(0, this.maxVisible)
        }
    }
})
</script>

<style scoped>
.system-info-wrapper {
    padding: 32px 16px 0 48px;
}

.system-info-header {
    display: block;
    margin-bottom: 8px;
}

.expand-btn {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    color: var(--accent-color-blue) !important;
    background: none;
    border: none;
    gap: 8px
}

.is-expanded{
    transform: rotate(180deg);
}

.anaplan-xl-actions {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.action-buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

</style>

